export const auth = {
    userName: 'userName',
};
